import { combineReducers } from "redux";
import { reducer as maintenanceReducer } from "./maintenance/maintenanceSlice";
import { IApplicationState } from "./types";

export const rootReducer = () =>
  combineReducers<IApplicationState>({
    maintenance: maintenanceReducer,
  });
